import React from 'react';
import { FaCar } from 'react-icons/fa';
import { Link } from 'react-router-dom'; 

const CtaBanner = () => {
  return (
    <section className="px-4 sm:px-6 lg:px-8 py-12">
      <div 
        // Updated: New container design with a custom shadow and hover effect
        className="bg-slate-900 rounded-3xl py-16 px-8 text-center relative overflow-hidden transition-all duration-300 ease-in-out hover:shadow-[0_0_50px_10px_rgba(251,191,36,0.5)] hover:scale-[1.02]"
      >
        {/* Updated: Changed the color of the car icon to amber */}
        <FaCar className="absolute -right-10 -bottom-16 text-amber-400 opacity-10 text-9xl" style={{ fontSize: '20rem' }} />
        
        <div className="relative z-10">
          <h2 className="text-3xl font-bold text-white mb-4">
            Enjoy every mile with adorable companionship.
          </h2>
          <p className="text-slate-400 mb-8 max-w-2xl mx-auto">
            Get started with our car rental service and get the best deals 
            for your journey.
          </p>
          {/* CRITICAL FIX: Changed <a> tag to <Link> and set to="/vehicles" */}
          <Link 
            to="/vehicles" 
            className="inline-flex items-center space-x-2 bg-slate-950 text-amber-400 ring-2 ring-amber-400 font-bold py-3 px-8 rounded-full hover:bg-amber-400 hover:text-black transition duration-300"
          >
            <span>Get Started</span>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default CtaBanner;